<template>
  <a-modal
    width="1200px"
    v-model="isShow"
    title="订单详情"
    :mask-closable="false"
    :body-style="{ paddingLeft: 0 }"
  >
    <a-row type="flex" :gutter="24">
      <a-col flex="200px">
        <a-menu
          class="left-menus"
          mode="vertical"
          :default-selected-keys="[currentComponent]"
          @select="handleSelectMenu"
        >
          <a-menu-item
            v-for="item in tabs"
            :key="item.component"
          >
            <a-icon :type="item.icon" :style="{fontSize: '20px'}" />
            {{ item.name }}
          </a-menu-item>
        </a-menu>
      </a-col>

      <a-col flex="990px" class="right-content">
        <keep-alive>
          <component
            :is="currentComponent"
            :service-order-id="id"
            ref="child"
          />
        </keep-alive>
      </a-col>
    </a-row>
    <template slot="footer">
      <a-button type="primary" @click="closeModal">关闭</a-button>
    </template>
  </a-modal>
</template>

<script>

export default {
  name: 'ShowOrder',
  components: {
    BasicInformation: () => import('@/views/home/big_screen/show_order/BasicInformation'),
    DirectorInfo: () => import('@/views/home/big_screen/show_order/DirectorInfo'),
    ConfirmNode: () => import('@/views/home/big_screen/show_order/ConfirmNode')
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      order: {},
      currentComponent: 'BasicInformation',
      tabs: [
        {
          component: 'BasicInformation',
          name: '基本信息',
          icon: 'profile'
        },
        {
          component: 'DirectorInfo',
          name: '理事信息',
          icon: 'inbox'
        },
        {
          component: 'ConfirmNode',
          name: '确认单',
          icon: 'inbox'
        }
      ]
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleSelectMenu({ item, key, selectedKeys }) {
      this.currentComponent = key
    },
    closeModal() {
      this.isShow = false
    }
  }
}
</script>

<style lang="less" scoped>
.left-menus {
  height: 110%;
  margin-top: -23px;
  background-color: #37543e;
}

.right-content {
  height: 500px;
  overflow: auto;
}

.left-menus /deep/ .ant-radio-button-wrapper {
  height: 50px;
  width: 160px;
  padding: 0;
  border: none;
  line-height: 48px;
  display: block;
  text-align: center;
}

.left-menus /deep/ .ant-menu-item {
  font-size: 20px !important;
}

/deep/ .ant-modal-content {
  background-color: #2a4c39;
}

/deep/ .ant-modal-header {
  border-bottom: 1px solid #848484;
  background-color: #2a4c39 !important;

  .ant-modal-title {
    font-size: 20px;
    color: @white !important;
  }
}

/deep/ .ant-modal-body {
  color: @white;
}

/deep/ .ant-modal-footer {
  border-top: none;
  text-align: center;
  background-color: #2a4c39 !important;
}

.cancel-btn {
  width: 150px;
  font-size: 20px !important;
  border: none;
}

/deep/ .submit-btn.ant-btn:hover {
  color: rgba(0, 0, 0, 65%);
}

/deep/ .submit-btn.ant-btn:focus {
  color: rgba(0, 0, 0, 65%);
}

/deep/ .ant-divider-horizontal {
  background-color: #848484;
}
</style>
